import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { tradingKeys } from '../tradingQueryKeys'
import { createListing } from '../tradingEndpoints'
import { parseMyListingDetail } from '../tradingParser'
import type { CreateListingInput } from '../../types/tradingTypes'

// Submit a new sell listing — it starts "Under Review" and locks the tokens.
export function useCreateListingMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateListingInput) => createListing(input).then(parseMyListingDetail),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradingKeys.myListings() })
      queryClient.invalidateQueries({ queryKey: tradingKeys.holdings() })
    },
  })
}
